"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_control__panel__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "deb8ff8c-e1ba-4c1c-ab2b-bb410043900d",
    x1: 98.79,
    y1: 91.65,
    x2: 136.19,
    y2: 136.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d9274840-712b-4987-877b-33fb47156903",
    x1: 132.59,
    y1: 74.32,
    x2: 154.43,
    y2: 92.65,
    xlinkHref: "#deb8ff8c-e1ba-4c1c-ab2b-bb410043900d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a5f32a3c-936c-40bc-aa92-c3ac3b09ba8a",
    x1: 63.83,
    y1: 115.81,
    x2: 94.83,
    y2: 154.56,
    xlinkHref: "#deb8ff8c-e1ba-4c1c-ab2b-bb410043900d"
  })), /*#__PURE__*/React.createElement("title", null, "control-panel-hi-dark"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "615ec2f5-70c1-45bd-bddc-84c86584f893",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.02,
    y: 24,
    width: 144,
    height: 144,
    rx: 15.93,
    ry: 15.93,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.08,166H40A16,16,0,0,1,24,150.07v2A16,16,0,0,0,40,168H152.08A16,16,0,0,0,168,152.07v-2A16,16,0,0,1,152.08,166Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "2fa16197-0554-47d3-900b-08ba0fad89e8",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "0c402c63-a38a-41c0-a87e-475b067baf84",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "59a145c3-9f34-46df-89ca-24a583d7ae0f",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2cc84a80-688b-41b8-9863-3c1351a2e4ad",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "92d43e08-8806-47e6-a9de-abb0efebca89",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "26856859-7389-40d6-a427-28376e4cb67e",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f9ca00a0-a531-40f9-b0f8-c71980ef2048",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1273e043-5aa1-4688-a2f3-ec2df88e46b8",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,47.34v96c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66v-96c0-1.55,1.8-3.34,4-3.34h0C98.23,44,100,45.79,100,47.34Z",
    transform: "translate(0 0)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "40301b66-97fe-4759-9c6a-a73506418894",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6b7526d0-634a-49ec-9884-79d593dfeca7",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "60e08f82-7fae-4fd5-a11e-89ae3478e9b2",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb282a58-17db-4b99-8806-6308caf849ff",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2f3b9184-724d-47d5-8331-3e20ec8c1ec6",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb6eac63-2e74-4ba5-a1d3-b5c911cc8032",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "185fd6a5-31be-4247-b3cd-b3bb6df933e2",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2c73e142-cda3-450d-94a4-f8efe28df7f9",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,49.89v93.45c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66V49.89c0-1.54,1.8-3.33,4-3.33h0C98.23,46.56,100,48.35,100,49.89Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }))))))))), /*#__PURE__*/React.createElement("polygon", {
    points: "81.05 103.02 129.67 151.64 166.25 140.15 111.05 84.96 81.05 103.02",
    opacity: 0.2,
    fill: "url(#deb8ff8c-e1ba-4c1c-ab2b-bb410043900d)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 84,
    width: 32,
    height: 20,
    rx: 3.44,
    ry: 3.44,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.56,102H83.44A3.44,3.44,0,0,1,80,98.56v2A3.44,3.44,0,0,0,83.44,104h25.12a3.44,3.44,0,0,0,3.44-3.44v-2A3.44,3.44,0,0,1,108.56,102Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "5cf1fc45-7f29-44d7-a350-ebd59927eee8",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "4c2011be-fc21-40e1-9e74-8babec6916d5",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fde01d77-c0cf-4851-b5f7-6e95f59ab37b",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ea066562-7c4e-41e4-b10e-f117430d4a64",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6a7fb7dd-28f8-4547-bc5f-8001375f9b25",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "250461e0-ca69-406c-a172-72ccb047c2c0",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "222c7104-463a-4683-ba72-f23bea94dc98",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d0f0a9a5-1627-4bce-99c0-6fd73aaf93de",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136,47.34v96c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66v-96c0-1.55,1.8-3.34,4-3.34h0C134.23,44,136,45.79,136,47.34Z",
    transform: "translate(0 0)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "5bdcf013-c528-46c3-96b7-08a4fa9eb981",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ad1fdaff-612d-423a-901b-6b135059af6d",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "788751e9-a8cf-4796-8355-5d25bb44f447",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9f7fd5af-e997-4758-99af-88f2bae5ddb4",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2e9041bd-d264-442d-80ba-36bb8d3b6e55",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7ff29a53-dd08-46f8-9a81-93ccdf421396",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d965a938-9a9e-4d8c-b3cf-908021543fe4",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0c2c2779-6b16-48da-8ac7-72d5faff68b2",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136,49.89v93.45c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66V49.89c0-1.54,1.8-3.33,4-3.33h0C134.23,46.56,136,48.35,136,49.89Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }))))))))), /*#__PURE__*/React.createElement("polygon", {
    points: "117.05 78.99 165.67 127.61 165.51 79.39 147.05 60.93 117.05 78.99",
    opacity: 0.2,
    fill: "url(#d9274840-712b-4987-877b-33fb47156903)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 59.97,
    width: 32,
    height: 20,
    rx: 3.44,
    ry: 3.44,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.56,78H119.44A3.44,3.44,0,0,1,116,74.53v2A3.45,3.45,0,0,0,119.44,80h25.12A3.45,3.45,0,0,0,148,76.53v-2A3.44,3.44,0,0,1,144.56,78Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "2ff31be1-6cc7-4072-ac2f-9e29db18a17f",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "c0588931-7075-4353-86a4-9d140f54b550",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d62f375e-1dbd-4570-8a2e-51f49d716e20",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4814e9ca-f867-4b0e-b80a-4a457dc3fd4c",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f20a6cd3-56e3-4a9e-85e2-291e83473405",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "db403dfe-fa3a-4c90-bf57-210bb8bfa3f4",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a09da7b8-33ed-4a6a-807f-616b4cb91d37",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e22326d6-3cf7-43d0-bcf7-84c5b2c8c051",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,47.34v96c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66v-96c0-1.55,1.8-3.34,4-3.34h0C62.23,44,64,45.79,64,47.34Z",
    transform: "translate(0 0)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "3d1538cf-b9be-49c7-959e-9cfbee9fcaa1",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1fbd58e3-329a-4ac4-831b-6796ba7883d7",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "305ffa3b-8800-437f-82cf-5c75b0a20070",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01a66d9a-0684-4ecd-a150-8f0d8cad9723",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f69048aa-7d63-4aa9-a15b-cd267425a8ff",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cb78034f-e73a-469a-a4f4-efba22deaf30",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6a8a11d1-e43c-44dc-b4f6-3f54b46c5955",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2c797065-ca00-4f2b-afc7-4e1da9071b87",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,49.89v93.45c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66V49.89c0-1.54,1.8-3.33,4-3.33h0C62.23,46.56,64,48.35,64,49.89Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }))))))))), /*#__PURE__*/React.createElement("polygon", {
    points: "45.05 127.02 83.73 165.71 130.25 164.16 75.05 108.96 45.05 127.02",
    opacity: 0.2,
    fill: "url(#a5f32a3c-936c-40bc-aa92-c3ac3b09ba8a)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 108,
    width: 32,
    height: 20,
    rx: 3.44,
    ry: 3.44,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.56,126H47.44A3.44,3.44,0,0,1,44,122.56v2A3.44,3.44,0,0,0,47.44,128H72.56A3.44,3.44,0,0,0,76,124.56v-2A3.44,3.44,0,0,1,72.56,126Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })))));
}

var _default = ic_control__panel__dark;
exports.default = _default;